export class ChoiceSliderItem {
  public graphic: string = null;
  public key: string = null;
  public unlimited = false;
}
